module.exports = __webpack_public_path__ + "img/appIcon.b515ce19.png";